function setMetaDescription(desc) {
  removeMetaDescription()
  let meta = document.createElement('META')
  meta.setAttribute('name', 'description')
  meta.setAttribute('content', desc)
  document.head.append(meta)
}

function removeMetaDescription() {
  let items = document.querySelectorAll('meta[name=description]')
  if(items.length) {
    for(let item of items) {
      item.remove()
    }
  }
}

export {
  setMetaDescription, removeMetaDescription
}